module.exports = __webpack_public_path__ + "media/images/stock_groups/f21d-410b2677f74aa746118d208eaac31f95.svg";